module.exports = __webpack_public_path__ + "img/additional-arrow.6ee4f341.svg";